// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Checkout__cart__root cmp-Checkout__flow__footer"};